(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/racing2/assets/javascripts/racing-widget.js') >= 0) return;  svs.modules.push('/widgets/racing2/assets/javascripts/racing-widget.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs.widget = svs.widget || {};
svs.widget.racing2 = svs.widget.racing2 || {};
const logger = svs.core.log.getLogger('widget:racing2');
const {
  throttle
} = svs.components.lbUi.Breadcrumbs.utils;
function bannerTypeToInitFunc(type) {
  switch (type) {
    case 'PIX':
      return svs.racing.pix_banner.init;
    case 'HighFiveNextRace':
      return svs.racing.high_five_next_race.init;
    default:
      return undefined;
  }
}
function checkStoredBet() {
  svs.components.Storage.browser.get('quickPlayRacing', 'quickplay', storedBet => {
    if (storedBet && Object.prototype.hasOwnProperty.call(storedBet, 'product') && Object.prototype.hasOwnProperty.call(storedBet, 'price')) {
      svs.core.module.load('/cl/racing/pix-dialog', undefined, error => {
        if (error) {
          logger.error('Could not load pix', error);
        } else {
          svs.racing.pix_dialog.openStoredBet(storedBet);
        }
      });
    }
  });
}
function observeContainerWidths() {
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(throttle(entries => {
      window.requestAnimationFrame(() => {

        const defaultBreakpoints = {
          md: 500
        };
        entries.forEach(entry => {
          if (entry.contentRect.width <= defaultBreakpoints.md) {
            entry.target.classList.add('sm');
          } else {
            entry.target.classList.remove('sm');
          }
        });
      });
    }, 60));
    const elements = document.querySelectorAll('[data-observe-resizes]');
    for (let i = 0; i < elements.length; i++) {
      ro.observe(elements[i]);
    }
  }
}
svs.widget.racing2.init = function (options) {
  new svs.components.ContentReveal({
    el: options.$el.find('.js-racing-banners')
  });
  options.model.items.forEach((item, index) => {
    const initFunc = bannerTypeToInitFunc(item.bannerType);
    if (initFunc) {
      const itemElement = options.$el.find(".js-racing-banner-".concat(index));
      initFunc(_objectSpread({
        el: itemElement
      }, item));
    }
  });
  document.querySelectorAll('[data-observe-resizes]').length > 0 && observeContainerWidths();
  checkStoredBet();
};

 })(window);